import './recipients-info-tooltip.directive.ajscss';

import { CommentDirectiveLinkFunction } from '@commons/toolbox/comment/comment.directive';

import templateUrl from './recipients-info-tooltip.directive.html';

export let RecipientsInfoTooltipDirective = () => ({
  restrict: 'E',
  transclude: true,
  scope: {
    icone: '@?',
    transcludeActivated: '@?',
    readOnly: '@?',
    position: '@?',
    text1: '<?',
    text2: '<?',
    containerSelector: '@?',
    alignBottomWithParent: '@?',
  },
  link: CommentDirectiveLinkFunction,
  templateUrl,
});

export default 'recipientsInfoTooltip';
